import { useStaticQuery, graphql } from 'gatsby';
import { withPrefix } from 'gatsby-link';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import {
  getBackgroundColorFromContentfulType,
  getHumanReadableContentTypeFromContentfulType,
  getSlugFromContentfulType,
} from 'helpers/contentfulTypes';

import Card from 'components/Card';
import Tag from 'components/Tag';

import {
  A,
  Content,
  Flex,
  PhotoContainer,
  PhotoWrapper,
} from 'components/FeaturedStyles';

const Featured = () => {
  const data = useStaticQuery(graphql`
    {
      allContentfulPage(
        filter: { featured: { eq: true }, discoverable: { eq: true } }
        limit: 1
      ) {
        edges {
          node {
            title
            slug
            shortDescription
            content {
              contentfulType: __typename
            }
            featuredImage {
              fluid {
                src
              }
            }
          }
        }
      }
    }
  `);

  const {
    content,
    featuredImage,
    shortDescription,
    slug,
    title,
  } = data.allContentfulPage.edges[0].node;
  const { contentfulType } = content[0];

  return (
    <A
      href={withPrefix(`${getSlugFromContentfulType(contentfulType)}/${slug}`)}
    >
      <Card>
        <Flex>
          <PhotoWrapper>
            <PhotoContainer
              className="photoContainer"
              css={css`
                background-image: url(${featuredImage.fluid.src});
              `}
            />
          </PhotoWrapper>
          <Content>
            <div>
              <Tag
                bg={getBackgroundColorFromContentfulType(
                  content[0].contentfulType
                )}
                textColor={waffles => waffles.theme.colors.white}
              >
                {getHumanReadableContentTypeFromContentfulType(
                  content[0].contentfulType
                )}
              </Tag>
              <h2>{title}</h2>
              {shortDescription}
            </div>
          </Content>
        </Flex>
      </Card>
    </A>
  );
};

export default Featured;
